import { Avatar, Box, Typography } from '@mui/material';
import { useRecordContext } from 'react-admin';
import { useResource } from '@app/misc/useResource';
import { ResourceLight } from '@wwf/sdk';

export interface MissionTypeLightCardRecord {
    id: string;
    name: string;
    icon?: ResourceLight | null;
}

export const MissionTypeLightCard = (props: {
    record?: MissionTypeLightCardRecord;
}) => {
    const record = useRecordContext<MissionTypeLightCardRecord>(props);
    const { data: src } = useResource(record?.icon?.id);

    const content = (
        <Box display="flex" alignItems="center" gap={0.5}>
            <Avatar
                variant="rounded"
                src={src ?? undefined}
                sx={{ width: 32, height: 32, borderRadius: 1 }}
            >
                {!src && (record?.name ?? '').charAt(0).toUpperCase()}
            </Avatar>
            <Typography variant="body2" noWrap>
                {record?.name}
            </Typography>
        </Box>
    );

    return content;
};
